module.exports = __webpack_public_path__ + "static/media/woodwind_village_Master_Deed.6b6e0151.pdf";